
import React, { Component, Fragment} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LandingPage from '../LandingPage/LandingPage';
import CardActivationPage from '../CardActivationPage/CardActivationPage';
import PinRetrievalPage from '../PinRetrievalPage/PinRetrievalPage';
import BalancePage from '../BalancePage/BalancePage';
import DealsPage from '../Deals/DealsPage';
import ContactPage from '../ContactPage/ContactPage';
import SuccessEmailPage from '../SuccessEmailPage/SuccessEmailPage';
import EmailVerifiedPage from '../EmailVerifiedPage/EmailVerifiedPage';
import SessionExpiredPage from '../SessionExpiredPage/SessionExpiredPage';
import VerifyEmailPage from '../VerifyEmailPage/VerifyEmailPage';
import DealsPreview from '../DealsPreview/DealsPreview';
import TermsPage from '../TermsPage/TermsPage';
import FAQPage from '../FAQPage/FAQPage';
import PrivacyPolicyPage from '../PrivacyPolicyPage/PrivacyPolicyPage';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import Loading from '../../components/Loading/Loading';
import SessionStorage from '../../storage/SessionStorage/SessionStorage';
import AccountVerificationPage from "../AccountVerificationPage/AccountVerificationPage";
import ResetPasswordPage from "../ResetPasswordPage/ResetPasswordPage";
import RequestNewPasswordPage from "../RequestNewPasswordPage/RequestNewPasswordPage";
// const PrivateRoute = ({ component: Component, appState, update, url, ...rest }) => (
//   <Route {...rest} render={(props) => (
//     appState.session.accessBalance === false
//       ? <Component {...props} />
//       : <Redirect to={`${url}`} />
//   )} />
// )

const PrivateRoute = ({component: Component, authed, appState, update, url, ...rest}) => {
  return (
    <Route {...rest} render={(props) => SessionStorage.getSessionStorageItem('bal') === '4061ddbfe486cce727972d8abc85171005b2911c3fb21aabd2481bab12fdba1b'
        ? <Component {...props} appState={appState} update={update} url={url}/>
        : <Redirect to={{pathname: `${url}`, state: {from: props.location}}} />}
    />
    // <Route {...rest} render={(props) => true === true
    //     ? <Component {...props} appState={appState} update={update} url={url}/>
    //     : <Redirect to={{pathname: `${url}`, state: {from: props.location}}} />}
    // />
  )
}


class Site extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
    
    this.asyncUpdate = this.asyncUpdate.bind(this);
    this.handleStatusMessage = this.handleStatusMessage.bind(this);
  };

  createSchemaAndClientCode = (schema, client) => {
    let route = '';
    if (schema !== undefined) {
      route += schema.toLowerCase();
    }
    if (client !== undefined) {
      route += `_${client.toLowerCase()}`;
    }
    return route;
  }

  handleStatusMessage(isVisible, message, type) {
    this.props.update({
      cardActivation: {
        status: {
          isVisible: isVisible,
          message: message,
          type: type
        }
      }
    });
  };

  validateRoute(schema, client) {
    let routes = ['card-activation', 'pin-retrieval', 'balance', 'terms', 'faq', 'not-found','account-verification','request-new-password','reset-password', 'terms/ticket-restaurant-card','terms/incentive-award-card','terms/compliments-card', 'faq/incentive-award-card', 'faq/ticket-restaurant-card', 'faq/compliments-card', '/', 'deals', 'contacts', 'dealspreview', 'emailverified', 'sessionexpired', 'verifyemail'];
    let route = { schema: undefined, client: undefined };
    if (routes.includes(this.props.match.params.schema) === false) {
      route.schema = schema;
    }
    if (routes.includes(this.props.match.params.client) === false) {
      route.client = client;
    }
    return route
  }
  
  asyncUpdate(newState) {
    this.props.update({
      async: Object.assign({}, this.props.data, newState)
    });
  }

  componentDidMount() {
    this.setState({ loading: true});

    if (this.props.route.schema === undefined && this.props.route.client === undefined) {
      let route = this.validateRoute(this.props.match.params.schema, this.props.match.params.client);
      let code = this.createSchemaAndClientCode(route.schema, route.client);

      if (code !== undefined && code.length > 0) {

        this.props.api.getTermsAndConditions().then(response => {
          if (response !== null && response.Settings) {
            //console.log("settings", response.Settings)
            this.props.setStaticPagesContent(response.Settings);
          }
        }).catch(error => {
          // console.error(error);
        });

        this.props.api.getExtranetSiteRulesWithCode(code, 'en-gb')
            .then(response => {
              this.setState({ loading: false});
              if (response !== null && response.Code) {
                this.props.validateCodeAndStoreSettings(response.Code, response.Settings);
              } else {
                this.props.update({
                  route: {
                    schema: undefined,
                    client: undefined
                  }
                });
              }
            })
            .catch(error => {
              // console.error(error);
            });
      } else {
        this.setState({ loading: false});
      }
    }



  }

  componentDidUpdate() {
    if (this.props.match.params.schema === '' && this.props.match.params.client === '') {
      this.props.update({
        route: {
          schema: undefined,
          client: undefined
        }
      });
    }
  }

  render() {
    let route = '';
    let uri = '';
    // let query = this.props.location;
    /* CLIENT */
    if (this.props.route.schema !== undefined && this.props.route.client !== undefined) {
      route = `/${this.props.route.schema}/${this.props.route.client}`
      uri = route;
    }
    /* SCHEMA */
    if (this.props.route.schema !== undefined && this.props.route.client === undefined) {
      route = `/${this.props.route.schema}`
      uri = route;
    }
    /* DEFAULT */
    if (this.props.route.schema === undefined) {
      route = `/`
      uri = '';
    }

    if (this.state.loading) {
      return (
        <Loading loading={this.state.loading}/>
      )
    }
    return (
      <Fragment>
        <Switch >
          <Route exact path={route} render={() => 
            <LandingPage 
              appState={this.props.appState}
              update={this.props.update}
              url={route} />
          } />
          <Route exact path={`${uri}/card-activation`} render={() => 
            <CardActivationPage 
              appState={this.props.appState} 
              api={this.props.api} 
              update={this.props.update}
              validateCodeAndStoreSettings={this.props.validateCodeAndStoreSettings}
              validateCodeAndReturnRoute={this.props.validateCodeAndReturnRoute}
              url={route} />
          } />
          <Route exact path={`${uri}/pin-retrieval`} render={() => 
            <PinRetrievalPage 
              appState={this.props.appState}
              api={this.props.api} 
              update={this.props.update}
              validateCodeAndStoreSettings={this.props.validateCodeAndStoreSettings}
              validateCodeAndReturnRoute={this.props.validateCodeAndReturnRoute}              
              url={route} />
          } />

          {/* <Route exact path={`${uri}/balance`} render={() =>
            <BalancePage
              appState={this.props.appState}
              update={this.props.update}
              url={route} />
          } />

          <Route exact path={`${uri}/newpassword`} render={() =>
            <NewPassword
              appState={this.props.appState}
              update={this.props.update}
              url={route} />
          } /> */}

           <Route exact path={`${uri}/deals`} render={() =>
            <DealsPage
              appState={this.props.appState}
              update={this.props.update}
              url={route} />
          } />

          <Route exact path={`${uri}/contact`} render={() =>
              <ContactPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route} />
          } />
          <PrivateRoute exact path={`${uri}/balance`} component={BalancePage} appState={this.props.appState} update={this.props.update} url={route} />

          <Route exact path={`${uri}/success`} component={(props) =>
              <SuccessEmailPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route}
                  location={props.location}
              />
          } />

          <Route exact path={`${uri}/emailverified`} render={(props) =>
              <EmailVerifiedPage
                appState={this.props.appState}
                update={this.props.update}
                url={route}
                location={props.location}
              />
          } />
          <Route exact path={`${uri}/sessionexpired`} render={(props) =>
              <SessionExpiredPage
                appState={this.props.appState}
                update={this.props.update}
                url={route}
                location={props.location}
              />
          } />

          <Route exact path={`${uri}/verifyemail`} render={(props) =>
              <VerifyEmailPage
                appState={this.props.appState}
                update={this.props.update}
                url={route}
                location={props.location}
                api={this.props.api}
              />
          } />

          <Route exact path={`/dealspreview`} component={(props) =>
              <DealsPreview
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route}
                  location={props.location}
              />

          } />
          <Route exact path={`${uri}/terms`} render={() =>
              <TermsPage
                  appState={this.props.appState}
                  update={this.props.update}
                  api={this.props.api}
                  url={route} />
          } />

          <Route exact path={`/terms/ticket-restaurant-card`} render={() =>
              <TermsPage
                  type={'tr'}
                  appState={this.props.appState}
                  update={this.props.update}
                  api={this.props.api}
                  url={route} />
          } />
          <Route exact path={`/terms/incentive-award-card`} render={() =>
              <TermsPage
                  type={'iac'}
                  appState={this.props.appState}
                  update={this.props.update}
                  api={this.props.api}
                  url={route} />
          } />
          <Route exact path={`/terms/compliments-card`} render={() =>
              <TermsPage
                  type={'cc'}
                  appState={this.props.appState}
                  update={this.props.update}
                  api={this.props.api}
                  url={route} />
          } />
          <Route exact path={`/account-verification`} render={() =>
              <AccountVerificationPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route}
                  api={this.props.api}
                  handleStatusMessage= { this.handleStatusMessage}
              />
          } />
          <Route exact path={`/reset-password`} render={() =>
              <ResetPasswordPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route}
                  api={this.props.api}
                  handleStatusMessage= { this.handleStatusMessage}
              />
          } />

          <Route exact path={`/request-new-password`} render={() =>
              <RequestNewPasswordPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route}
                  api={this.props.api}
                  handleStatusMessage= { this.handleStatusMessage}
              />
          } />
          <Route exact path={`${uri}/faq`} render={() => 
            <FAQPage 
              appState={this.props.appState}
              update={this.props.update}
              url={route} />
          } />

          <Route exact path={`${uri}/privacy-policy`} render={() =>
              <PrivacyPolicyPage
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route} />
          } />

          <Route exact path={`/faq/incentive-award-card`} render={() =>
              <FAQPage
                  type={'iac'}
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route} />
          } />
          <Route exact path={`/faq/ticket-restaurant-card`} render={() =>
              <FAQPage
                  type={'tr'}
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route} />
          } />
          <Route exact path={`/faq/compliments-card`} render={() =>
              <FAQPage
                  type={'cc'}
                  appState={this.props.appState}
                  update={this.props.update}
                  url={route} />
          } />
          <Route render={() =>
            <NotFoundPage
              appState={this.props.appState}
              url={route} />
          } />
        </Switch>

        { this.props.appState.loading 
        ? 
          <Loading loading={this.props.appState.loading}/>
        : 
          null
        }

      </Fragment>
    );
  }
}

export default Site;


// WEBPACK FOOTER //
// ./src/containers/Site/Site.js